import React from 'react';
import { useParams } from 'react-router-dom';
import { SxStyle } from '../../../types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import PushNotificationList from './arena-configurator-components/push-notification-list';
import AppWifiCardForm from './arena-configurator-components/app-wifi-card-form';
import ArenaForm from './arena-configurator-components/arena-form';
import { useDocumentData, useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import firebaseApp from '../../../firebase-app';
import { ParamTypes, Team } from './types';
import { useStringsContext } from '../../../contexts/strings';
import { collection, doc, updateDoc } from 'firebase/firestore';

const styles: SxStyle = {
  root: {
    minWidth: 275,
    padding: '20px',
  },
  header: {
    paddingBottom: '4px',
    paddingLeft: '8px',
  },
};

function ArenaConfigurator() {
  const { strings } = useStringsContext();
  const { arena } = useParams<ParamTypes>();
  const firestorePath = `/wifi/sv/venue-configs/${arena}`;
  const [arenaConfig, loading] = useDocumentData<any>(doc(firebaseApp.db, firestorePath));

  const [teams, loadingTeams] = useCollectionDataOnce(collection(firebaseApp.db, `/teams`));

  const submitNewPushChannelList = async (newChannelList: string[]) => {
    const docRef = doc(firebaseApp.db, firestorePath);
    await updateDoc(docRef, {
      venue: {
        homeTeamIds: arenaConfig?.venue.homeTeamIds,
        homeTeamNames: arenaConfig?.venue.homeTeamNames,
        pushChannels: newChannelList,
        name: arenaConfig?.venue.name,
      },
      message: arenaConfig?.message,
    });
  };

  const submitNewVenueConfig = async (config: any) => {
    const docRef = doc(firebaseApp.db, firestorePath);
    await updateDoc(docRef, {
      venue: {
        homeTeamIds: config.homeTeamIds,
        homeTeamNames: config.homeTeamNames,
        pushChannels: arenaConfig?.venue.pushChannels,
        name: config.name,
      },
      message: arenaConfig?.message,
    });
  };

  const submitNewMessageConfig = async (newMessage: any) => {
    const docRef = doc(firebaseApp.db, firestorePath);
    await updateDoc(docRef, {
      venue: arenaConfig?.venue,
      message: newMessage,
    });
  };

  if (!loading && !arenaConfig) {
    return <Typography>{'Arenakonfiguration saknas'}</Typography>;
  }

  if (!loading && arenaConfig && teams && !loadingTeams && arenaConfig) {
    return (
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography sx={styles.header}>{strings.wifi.arena}</Typography>
          <Paper sx={styles.root}>
            <ArenaForm
              arenaConfig={arenaConfig}
              submitNewVenueConfig={submitNewVenueConfig}
              teams={teams as Team[]}
            />
          </Paper>
        </Grid>
        <Grid container item xs spacing={2} alignContent={'flex-start'}>
          <Grid item xs>
            <Typography sx={styles.header}>{strings.wifi.pushNotifications}</Typography>
            <Paper sx={styles.root}>
              <PushNotificationList
                arenaConfig={arenaConfig}
                submitNewPushChannelList={submitNewPushChannelList}
              />
            </Paper>
          </Grid>
          <Grid item xs>
            <Typography sx={styles.header}>{strings.wifi.appWifiCard}</Typography>
            <Paper sx={styles.root}>
              <AppWifiCardForm
                arenaConfig={arenaConfig}
                submitNewMessageConfig={submitNewMessageConfig}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return null;
}

export default ArenaConfigurator;
